import(/* webpackMode: "eager" */ "/app/src/app/(landing)/cookie/page.tsx");
